// WHAT: React Query hook for fetching Miracle Flow dashboard statistics
// WHY:  Provides cached data fetching for dashboard stats with automatic refetching and error handling
// DOMAIN: Productivity → Miracle Flow → Analytics
// DEPENDENCIES: TanStack React Query, Tauri core API
// RISKS:
//   - NOTE: staleTime is set to 0 - may cause excessive API calls
//   - NOTE: refetchOnMount is 'always' - may cause unnecessary network requests
//   - WARN: throwOnError is false - errors may be silently ignored by components
//   - NOTE: GC time is 10 minutes - may hold stale data in memory

import type { DashboardStats } from "./useSessionStats";

import { useQuery } from "@tanstack/react-query";
import { core } from "@tauri-apps/api";

export const useDashboardStats = () => {
  return useQuery<DashboardStats>({
    gcTime: 1000 * 60 * 10, // 10 minutes
    queryFn: () => core.invoke<DashboardStats>("get_dashboard_stats"),
    queryKey: ["miracle-flow", "dashboard-stats"],
    refetchOnMount: "always", // Always refetch when component mounts, even if data is fresh
    refetchOnWindowFocus: true,
    retry: 2,
    staleTime: 0, // Always consider data stale, so it refetches on mount
    throwOnError: false,
  });
};
